module.exports = __webpack_public_path__ + "img/ic_jifb_hover.d55b76f8.png";